import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import getItemFromLocalStorage from "./utils/getItemFromLocalStorage";
import { authenticatedUser } from "./store/actions/auth.actions";
import App from "./App";
import store from "./store";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";

const user = getItemFromLocalStorage("user");
if (user) {
  store.dispatch(authenticatedUser(user));
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}> */}
    <FluentProvider theme={teamsLightTheme}>
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </Router>
    </FluentProvider>
    {/* </PersistGate> */}
  </Provider>
  // </React.StrictMode>
);
